export function toggleFAQ(triggerEl) {
	const item = triggerEl.closest('.rank-math-list-item');
	const answer = item.querySelector('.rank-math-answer');
	const isOpen = triggerEl.getAttribute('aria-expanded') === 'true';

	if (!answer) return;

	if (isOpen) {
		// Close it
		triggerEl.setAttribute('aria-expanded', 'false');
		answer.setAttribute('aria-hidden', 'true');
		answer.style.height = answer.scrollHeight + 'px'; // set current height

		// Animate to 0
		requestAnimationFrame(() => {
			answer.style.height = '0px';
		});
	} else {
		// Open it
		triggerEl.setAttribute('aria-expanded', 'true');
		answer.setAttribute('aria-hidden', 'false');

		// Set height to auto after animation
		answer.style.height = answer.scrollHeight + 'px';
		answer.addEventListener(
			'transitionend',
			function handleOpen() {
				if (triggerEl.getAttribute('aria-expanded') === 'true') {
					answer.style.height = 'auto'; // allow dynamic height
				}
				answer.removeEventListener('transitionend', handleOpen);
			},
			{ once: true }
		);
	}
}
